import React from 'react';
import { Link } from 'react-router-dom';

function CardItem(props) {
  return (
    <li className="program-card">
      <Link className="program-card__link tcc-card tcc-card--hover" to={props.path}>
        <div className="program-card__media">
          <img
            className="program-card__img"
            alt={props.alt || props.label || ''}
            src={props.src}
            loading="lazy"
          />
          <span className="program-card__tag">{props.tag || props.label}</span>
        </div>
        <div className="program-card__body">
          <h3 className="program-card__title">{props.label}</h3>
          <p className="program-card__text">{props.text}</p>
          <span className="program-card__cta" aria-hidden="true">Learn more →</span>
        </div>
      </Link>
    </li>
  );
}

export default CardItem;
